import React from 'react';
import RichTextImage from '../RichTextImage';

const RichTextEmbeddedAsset = ({ node }) => {
  const { file, title } = node?.data?.target || {};

  if (!file) {
    return null;
  }

  const { url, contentType } = file;

  if (contentType.includes('image') || contentType.includes('png')) {
    return <RichTextImage image={url} alt={title} />;
  }
  return null;
};

export default RichTextEmbeddedAsset;
